interface SchoolLogoProps {
  url?: string
}

export default function SchoolLogo({ url }: SchoolLogoProps) {
  if (import.meta.env.VITE_SHOW_LOGO_ON_REGISTRATION !== 'true') return null
  return url ? (
    <div className='flex justify-center pb-2'>
      <img
        src={url}
        alt='school logo'
        className='object-contain inline-block max-w-4/5 lg:max-w-1/2 max-h-48 shadow-md shadow-neutral-900'
      />
    </div>
  ) : null
}
